export default __webpack_public_path__ + "static/media/rake-structure.979a468c.webp";